import reducer from './reducers/mainReducer';
import type { AppState } from './reducers/mainReducer';
import storage from 'redux-persist/lib/storage';
import autoMergeLevel2 from 'redux-persist/lib/stateReconciler/autoMergeLevel2';
import { persistReducer, PersistConfig } from 'redux-persist';
import { legacy_createStore, compose, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import logger from 'redux-logger';

declare global {
  interface Window {
    __REDUX_DEVTOOLS_EXTENSION_COMPOSE__?: typeof compose;
  }
}

const composeEnhances = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const persistConfig: PersistConfig<AppState> = {
  key: 'root',
  storage,
  stateReconciler: autoMergeLevel2,
  blacklist: ['auth', 'notifications'],
};
const isDevelopment = import.meta.env.MODE === 'development';
const persistedReducer = persistReducer(persistConfig, reducer);

const middlewares = isDevelopment ? [thunk, logger] : [thunk];

export const store = legacy_createStore(
  persistedReducer,
  composeEnhances(applyMiddleware(...middlewares))
);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
